"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VueTranslatorComponent = exports.Translator = exports.i18n = void 0;
const vue_i18n_1 = require("vue-i18n");
const fetchWrapper_1 = __importDefault(require("./../utils/fetchWrapper"));
//import ConfiguredLocales from "./_locales";
const _datetimeFormats_1 = __importDefault(require("./_datetimeFormats"));
const _numberFormats_1 = __importDefault(require("./_numberFormats"));
const debounce_1 = __importDefault(require("lodash/debounce"));
//import DropdownItem from "../../components/Layout/Navigation/DropdownItem.vue";
//import DropdownMenu from "../../components/Layout/Navigation/DropdownMenu.vue";
const ShopConfig_1 = require("../utils/ShopConfig");
const FALLBACK_LOCALE = "en";
exports.i18n = (0, vue_i18n_1.createI18n)({
    legacy: false,
    locale: ((_a = document.querySelector("html")) === null || _a === void 0 ? void 0 : _a.lang) || "en",
    fallbackLocale: FALLBACK_LOCALE,
    formatFallbackMessages: true,
    // @ts-ignore
    messages: ShopConfig_1.ShopConfig.getTranslations(),
    datetimeFormats: _datetimeFormats_1.default,
    numberFormats: _numberFormats_1.default,
}).global;
class Translator {
    static trans(id, defaultTranslation = `${id}`, domain = "messages", parameters = {}, locale = "") {
        if (typeof exports.i18n === "undefined") {
            return id;
        }
        if (locale === "") {
            locale = exports.i18n.locale.value;
        }
        const message = `${domain}.${id.replace(/[\W]+/gi, "_")}`;
        if (!exports.i18n.te(message, locale)) {
            // message id does not defined in this locale, try fallback
            if (!exports.i18n.te(message, FALLBACK_LOCALE)) {
                Translator.collectMessage(id, domain, FALLBACK_LOCALE, defaultTranslation);
                return exports.i18n.rt(defaultTranslation, parameters, {
                    locale: FALLBACK_LOCALE,
                });
            }
            return exports.i18n.t(message, parameters, { locale: FALLBACK_LOCALE });
        }
        return exports.i18n.t(message, parameters, { locale: locale });
    }
    static n(value, key = "decimal", locale = "hu-HU") {
        if (typeof exports.i18n === "undefined") {
            return value;
        }
        return exports.i18n.n(value, key, locale);
    }
    static d(value, key, locale = "hu-HU") {
        if (typeof exports.i18n === "undefined") {
            return value;
        }
        return exports.i18n.d(value, key, locale);
    }
    static collectMessage(id, domain = "messages", locale, defaultTranslation) {
        if (locale === "" && typeof exports.i18n !== "undefined") {
            locale = FALLBACK_LOCALE;
        }
        Translator.pushMissingMessages([
            {
                domain: domain,
                locale: locale,
                id: id,
                defaultTranslation: defaultTranslation,
            },
        ]);
    }
    static pushMissingMessages(missingMessages) {
        missingMessages.forEach((message) => {
            const added = Translator.missingMessages.filter((added) => added.id === message.id &&
                added.locale === message.locale &&
                added.domain === message.domain).length !== 0;
            if (!added) {
                Translator.missingMessages.push(message);
            }
        });
        Translator.saveMissingMessages();
    }
}
Translator.missingMessages = [];
Translator._saving = false;
Translator.saveMissingMessages = (0, debounce_1.default)(() => {
    if (!Translator.missingMessages.length) {
        return;
    }
    if (Translator._saving) {
        return;
    }
    const missings = Translator.missingMessages;
    (0, fetchWrapper_1.default)("/api/save-missing-messages", {
        method: "POST",
        body: JSON.stringify(missings),
    })
        .then((response) => response.json())
        .then((data) => {
        Translator.missingMessages = [];
    })
        .catch((e) => {
        // failed saving, push back missing messages for later work
        Translator.pushMissingMessages(missings);
    });
}, 2500);
exports.Translator = Translator;
class VueTranslatorComponent {
    constructor() {
        this.installed = false;
    }
    /**
     * Vue.js component install method
     */
    install(app) {
        if (this.installed) {
            return;
        }
        this.installed = true;
        app.provide("Translator", this);
        app.config.globalProperties.$trans = (id, defaultTranslation = `${id}`, domain = "messages", parameters = {}, locale = "") => {
            return Translator.trans(id, defaultTranslation, domain, parameters, locale);
        };
        // commented out because of TS validation errors
        // referencing calls replaced with Translator.d and Translator.n
        // app.config.globalProperties.$d = (value: number | Date | string, key: string, locale: Locale) => {
        //     return i18n.d(value, key, locale);
        // };
        // app.config.globalProperties.$n = (value: number, key: string, locale: Locale = 'hu-HU') => {
        //     return i18n.n(value, key, locale);
        // };
    }
    trans(id, defaultTranslation = `${id}`, domain = "messages", parameters = {}, locale = "") {
        return Translator.trans(id, defaultTranslation, domain, parameters, locale);
    }
    n(value, key, locale = "hu-HU") {
        return Translator.n(value, key, locale);
    }
    d(value, key, locale = "hu-HU") {
        return Translator.d(value, key, locale);
    }
}
exports.VueTranslatorComponent = VueTranslatorComponent;
exports.default = new VueTranslatorComponent();
